// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {get,post,del} from './common/request.js';

Vue.config.productionTip = false

import 'lib-flexible/flexible';

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import axios from 'axios'
Vue.prototype.$axios = axios;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$del = del;

// 获取登录信息
import './router/login'


import api from '@/common/api.js';
Vue.prototype.$api = api;
import index from '@/common/index.js';
Vue.prototype.$commonjs = index;
import regular from '@/common/regular.js';
Vue.prototype.$regular = regular;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js